import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProductItem from './ProductItem';
import ProductsSearch from '../../product/components/ProductsSearch';

function ProductsSection({
  skeletonCount = 4,
  selectedBranchId = null,
}) {
  const navigate = useNavigate();

  const skeletonItems = React.useMemo(
    () => Array.from({ length: skeletonCount }, (_, i) => i),
    [skeletonCount]
  );

  return (
    <ProductsSearch
      branchId={selectedBranchId}
      emptyText="Продукты будут появляться здесь."
      toolbar={({ total, loading }) => (
        <div className="main-page-sectionHeader">
          <button
            type="button"
            className="main-page-sectionSubButton"
            onClick={() => navigate('/products/index')}
          >
            Порядок
          </button>
          <div className="main-page-sectionSub">
            <span>
              {loading && !total
                ? 'Загрузка…'
                : total
                  ? `${total} продуктов`
                  : 'Нет продуктов'}
            </span>
          </div>
        </div>
      )}
    >
      {({ products, loading, setProducts }) => {
        const handleProductDeleted = (deletedId) => {
          if (!deletedId) return;
          setProducts((prev) =>
            prev.filter((p) => {
              const pid = p?._id ?? p?.id;
              return pid !== deletedId;
            })
          );
        };

        const handleVariantDeleted = (groupId, variantId) => {
          if (!groupId || !variantId) return;
          setProducts((prev) =>
            prev.map((p) => {
              const pid = p?._id ?? p?.id;
              if (String(pid) !== String(groupId)) return p;
              const variants = Array.isArray(p.variants) ? p.variants : [];
              return {
                ...p,
                variants: variants.filter((v) => {
                  const vid = v?._id ?? v?.id;
                  return String(vid) !== String(variantId);
                }),
              };
            })
          );
        };

        if (loading && products.length === 0) {
          return (
            <div className="main-page-productList" aria-hidden="true">
              {skeletonItems.map((i) => (
                <div key={i} className="main-page-productItem main-page-productItem--skeleton">
                  <div className="main-page-productItemTop">
                    <div className="main-page-skeleton main-page-skeleton--block main-page-productSkeletonImage" />
                    <div className="main-page-productMain">
                      <div className="main-page-skeleton main-page-skeleton--text main-page-productSkeletonName" />
                      <div className="main-page-skeleton main-page-skeleton--text main-page-productSkeletonMeta" />
                    </div>
                    <div className="main-page-productActions">
                      <div className="main-page-skeleton main-page-skeleton--circle main-page-productSkeletonBtn" />
                      <div className="main-page-skeleton main-page-skeleton--circle main-page-productSkeletonBtn" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          );
        }

        return (
          <div className="main-page-productList">
            {products.map((p) => (
              <ProductItem
                key={p?._id ?? p?.id}
                product={p}
                onDeleted={handleProductDeleted}
                onVariantDeleted={handleVariantDeleted}
              />
            ))}
          </div>
        );
      }}
    </ProductsSearch>
  );
}

export default ProductsSection;
